import React, { useState, useRef } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FileUploadZone = ({ onFileSelect, isProcessing = false, acceptedFiles = [] }) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const handleDragOver = (e) => {
    e?.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e?.preventDefault();
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    e?.preventDefault();
    setIsDragOver(false);
    const files = Array.from(e?.dataTransfer?.files);
    const validFiles = files?.filter(file => 
      file?.type?.includes('sheet') || 
      file?.name?.endsWith('.xlsx') || 
      file?.name?.endsWith('.xls') || 
      file?.name?.endsWith('.csv') ||
      file?.type === 'application/json' ||
      file?.name?.endsWith('.json')
    );
    if (validFiles?.length > 0) {
      // Soporte multi-archivo: procesar todos los archivos válidos
      onFileSelect(validFiles);
    }
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e?.target?.files);
    if (files?.length > 0) {
      onFileSelect(files);
    }
  };

  const handleClick = () => {
    if (!isProcessing) {
      fileInputRef?.current?.click();
    }
  };

  return (
    <div className="bg-surface rounded-lg border border-border p-8">
      <div
        className={`border-2 border-dashed rounded-lg p-12 text-center transition-all duration-200 cursor-pointer ${
          isDragOver 
            ? 'border-primary bg-primary/5' 
            : isProcessing
            ? 'border-muted bg-muted/20 cursor-not-allowed' :'border-border hover:border-primary/50 hover:bg-muted/30'
        }`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={handleClick}
      >
        <div className="flex flex-col items-center space-y-4">
          <div className={`w-16 h-16 rounded-full flex items-center justify-center ${
            isProcessing 
              ? 'bg-muted text-muted-foreground' 
              : isDragOver 
              ? 'bg-primary/10 text-primary' :'bg-accent/10 text-accent'
          }`}>
            <Icon 
              name={isProcessing ? "Loader" : isDragOver ? "Upload" : "FileSpreadsheet"} 
              size={32}
              className={isProcessing ? "animate-spin" : ""}
            />
          </div>

          <div className="space-y-2">
            <h3 className="text-xl font-semibold text-text-primary">
              {isProcessing 
                ? 'Procesando archivo...' 
                : isDragOver 
                ? 'Suelta los archivo(s) aquí' :'Arrastra tu(s) archivo(s) aquí'
              }
            </h3>
            <p className="text-text-secondary">
              {isProcessing 
                ? 'Por favor espera mientras procesamos tu archivo' :'o haz clic para seleccionar desde tu computadora'
              }
            </p>
          </div>

          {!isProcessing && (
            <Button
              variant="outline"
              iconName="FolderOpen"
              iconPosition="left"
              onClick={(e) => {
                e?.stopPropagation();
                handleClick();
              }}
            >
              Seleccionar Archivos
            </Button>
          )}
        </div>

        <div className="mt-8 pt-6 border-t border-border">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-text-secondary">
            <div className="flex items-center space-x-2">
              <Icon name="FileCheck" size={16} className="text-success" />
              <span>Formatos: .xlsx, .xls, .csv, .json</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="HardDrive" size={16} className="text-warning" />
              <span>Tamaño máximo: 10MB</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Package" size={16} className="text-accent" />
              <span>Hasta 10,000 productos</span>
            </div>
          </div>
        </div>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        multiple={true}
        accept=".xlsx,.xls,.csv,.json,.zip"
        onChange={handleFileSelect}
        className="hidden"
        disabled={isProcessing}
      />
      {acceptedFiles?.length > 0 && (
        <div className="mt-4 space-y-2">
          <h4 className="font-medium text-text-primary">Archivos seleccionados:</h4>

        {/* MCO_SELECTED_FILES_GRID_V2 */}
        <div className="grid max-h-[520px] grid-cols-1 content-start items-stretch gap-2 overflow-y-auto pr-1 md:grid-cols-2 lg:grid-cols-3 [&>*]:min-w-0 [&>*]:rounded-xl [&>*]:!border [&>*]:!border-[#dfe7f3] [&>*]:!bg-white [&>*]:shadow-sm">
{acceptedFiles?.map((file, index) => (
            <div key={index} className="flex items-center space-x-3 p-3 bg-muted rounded-lg">
              <Icon name="FileSpreadsheet" size={20} className="text-success" />
              <div className="flex-1">
                <p className="font-medium text-text-primary">{file?.name}</p>
                <p className="text-sm text-text-secondary">
                  {(file?.size / 1024 / 1024)?.toFixed(2)} MB
                </p>
              </div>
              <div className="flex items-center space-x-1 text-success">
                <Icon name="CheckCircle" size={16} />
                <span className="text-sm">Válido</span>
              </div>
            </div>
          ))}
        </div>

        </div>
      )}
    </div>
  );
};

export default FileUploadZone;